import React, { Component } from 'react'
import { Icon, Spin, Table, Tag, Switch, Modal, Tooltip, Button, Form, Input, message } from 'antd';
import MenuSider from '../../../../components/MenuSider'
import ScrollToTop from '../../../../components/ScrollToTop'
import { Odata_Url, Constants } from '../../../../Constants/Constants'
import axios from 'axios'
import IntlMessages from '../../../../util/IntlMessages';

const { Column } = Table


const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
    <EditableContext.Provider value={form}>
        <tr {...props} />
    </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
    state = {
        editing: false,
    };

    toggleEdit = () => {
        const editing = !this.state.editing;
        this.setState({ editing }, () => {
            if (editing) {
                this.input.focus();
            }
        });
    };

    save = e => {
        const { record, handleSave } = this.props;
        this.form.validateFields((error, values) => {
            if (error && error[e.currentTarget.id]) {
                return;
            }
            this.toggleEdit();
            handleSave({ ...record, ...values });
        });
    };

    renderCell = form => {
        this.form = form;
        const { children, dataIndex, record, title } = this.props;
        const { editing } = this.state;
        return editing ? (
            <Form.Item style={{ margin: 0 }}>
                {form.getFieldDecorator(dataIndex, {
                    rules: [
                        {
                            required: true,
                            message: `${title} is required.`,
                        },
                    ],
                    initialValue: record[dataIndex],
                })(<Input ref={node => (this.input = node)} onPressEnter={this.save} onBlur={this.save} />)}
            </Form.Item>
        ) : (
                <div
                    className="editable-cell-value-wrap"
                    style={{ paddingRight: 24 }}
                    onClick={this.toggleEdit}
                >
                    {children}
                </div>
            );
    };

    render() {
        const {
            editable,
            dataIndex,
            title,
            record,
            index,
            handleSave,
            children,
            ...restProps
        } = this.props;
        return (
            <td {...restProps}>
                {editable ? (
                    <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
                ) : (
                        children
                    )}
            </td>
        );
    }
}





export default class RootCauseMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            category: [],
            cetegoryModel: {},
            rootcause: [],
            visible: false,
            onLoading: false
        }

        this.columns = [
            {
                title: 'Id',
                dataIndex: 'pkRootcauseID',
                width: 50,
                align: 'center',
                render: (value) => value > 0 ? value : ''
            },
            {
                title: 'Name (Thai)',
                dataIndex: 'rootcause',
                editable: true
            },
            {
                title: 'Name (Eng)',
                dataIndex: 'rootcause_EN',
                editable: true
            },
            {
                title: 'Is Active',
                dataIndex: 'isActived',
                width: 50,
                align: 'center',
                render: (value, record) => <Switch defaultChecked={value} onChange={() => record.isActived = !record.isActived} />
            },
            {
                title: 'Action',
                dataIndex: 'action',
                width: 50,
                align: 'center',
                render: (value, record) => record.pkRootcauseID < 0 ? <a onClick={() => this.handleDelete(record)}>Delete</a> : null
            }
        ]
    }

    componentDidMount() {
        this.getRootCause();
    }

    getRootCause() {
        var Token
        axios.get(Constants.BASE_URL + 'auth/token')
            .then(async (response) => {
                Token = response.data
                axios.get(Odata_Url + 'OCategoryMD?$filter=IsActived eq true',
                    { headers: { "Authorization": "Bearer " + Token } }).then((response) => {
                        const data = [];
                        response.data.value.forEach(function (element) {
                            data.push(element);
                        });
                        this.setState({
                            category: data
                        })
                    }, (error) => {
                        console.log(error);
                        if (401 === error.response.status) {
                            window.location.href = "auth";
                        }
                    });
            }, (error) => {
                console.log(error);
            });
    }

    handleClick(row) {

        this.getToken().then(token => {

            let tokenHeader = {
                headers: { "Authorization": "Bearer " + token }
            };

            axios.get(Constants.BASE_URL + 'api/Rootcause/GetRootCauseByCategoryId?Id=' + row.PKCategoryID, tokenHeader).then(res => {
                this.setState({ rootcause: res.data, cetegoryModel: row, visible: true })
            })
        });

       
    }

    handleAdd = (categoryID) => {
        const { rootcause } = this.state;
        let id = 0
        if (rootcause.length > 0)
            id = rootcause.reduce((prev, curr) => prev.pkRootcauseID < curr.pkRootcauseID ? prev : curr).pkRootcauseID
        id = id >= 0 ? -1 : id - 1

        const newData = {
            categoryID: categoryID,
            createDate: null,
            isActived: true,
            isDeleted: false,
            pkRootcauseID: id,
            rootcause: "",
            rootcause_EN: "",
            updateDate: null,
            userCreate: null,
            userUpdate: null,
        }

        this.setState({
            rootcause: [...rootcause, newData],
        });
    };

    handleSave = row => {
        const newData = [...this.state.rootcause];
        const index = newData.findIndex(item => row.pkRootcauseID === item.pkRootcauseID);
        const item = newData[index];
        newData.splice(index, 1, {
            ...item,
            ...row,
        });
        this.setState({ rootcause: newData });
    };

    handleDelete = row => {
        const dataSource = [...this.state.rootcause]
        this.setState({ rootcause: dataSource.filter(x => x.pkRootcauseID !== row.pkRootcauseID) })
    }

    handleOk = e => {
        let rootcauses = this.state.rootcause
        let empty_rootcause = rootcauses.filter(x => x.rootcause === '' || x.rootcause_EN === '').length
        if (empty_rootcause) {
            message.error('Please fill out all name(s)')
            return
        }
        this.setState({ onLoading: true })

        this.getToken().then(token => {

            let tokenHeader = {
                headers: { "Authorization": "Bearer " + token }
            };

            axios.post(Constants.BASE_URL + 'api/Rootcause/SaveRootCause', rootcauses, tokenHeader).then(res => {
                message.success('Your transaction has been successfully.')
                this.setState({ rootcause: [], visible: false, onLoading: false })
            }, error => {
                message.error(error)
                this.setState({ onLoading: false })
            })
        });
    }

    handleCancel = e => {
        this.setState({ rootcause: [], visible: false })
    }

    getToken() {
        var $getToken = new Promise((resolve, reject) => {
            axios.get(Constants.BASE_URL + 'auth/token').then((res) => {
                resolve(res.data);
            }).catch(err => {
                if (401 === err.response.status) {
                    window.location.href = "auth";
                }
                reject(err);
            });
        });
        return $getToken;
    }

    render() {
        const componants = {
            body: {
                row: EditableFormRow,
                cell: EditableCell
            }
        }
        const columns = this.columns.map(col => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    editable: col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: this.handleSave,
                }),
            };
        });
        return (
            <div style={{ width: "100%" }}>
                <Spin spinning={this.state.onLoading} size="large" className='spin' tip={<IntlMessages id='Loading' />}>
                    <ScrollToTop />
                    <MenuSider title="Master Root Cause">
                        <div style={{ margin: "10px" }}>
                            <Table dataSource={this.state.category}>
                                <Column
                                    title='Category Name (Thai)'
                                    dataIndex='Category_Name'
                                />
                                <Column
                                    title='Category Name (Eng)'
                                    dataIndex='Category_Name_EN'
                                />
                                <Column
                                    title='Type'
                                    dataIndex='Type_Category'
                                    align='center'
                                    render={type => (
                                        <span>
                                            {
                                                <Tag color={type == 'office' ? 'pink' : type == undefined ? 'red' : 'blue'} key={type}>
                                                    {type ? type.toUpperCase() : 'NOT SET'}
                                                </Tag>
                                            }
                                        </span>
                                    )}
                                />
                                <Column
                                    title='Status'
                                    dataIndex='IsActived'
                                    align='center'
                                    render={(active) => (
                                        <span>
                                            <Tag color={active ? 'green' : 'volcano'} key={active}>
                                                {active ? 'Active' : 'Inactive'}
                                            </Tag>
                                        </span>
                                    )}
                                />
                                <Column
                                    title='Action'
                                    width={100}
                                    align='center'
                                    render={(data, row) => (
                                        <div>
                                            <Tooltip title='Choose root cause into Category' placement='left' >
                                                <a href="javascript:;" onClick={() => this.handleClick(row)}>
                                                    <Icon type={"form"} style={{ fontSize: "17px" }} />
                                                </a>
                                            </Tooltip>

                                            {/* <Divider type="vertical" />
                                            <a href="javascript:;" onClick={() => this.handleClickDelete(row.PKJobTypeID - 1)}>
                                                <Icon type={"delete"} style={{ fontSize: "17px" }} />
                                            </a> */}
                                        </div>
                                    )}
                                />
                            </Table>
                        </div>
                    </MenuSider>
                    <Modal
                        title={'Choose root cause for ' + this.state.cetegoryModel.Category_Name}
                        visible={this.state.visible}
                        okText='Save'
                        onOk={this.handleOk}
                        onCancel={this.handleCancel}
                        confirmLoading={this.state.onLoading}
                        width='95%'
                    >
                        <Button onClick={() => this.handleAdd(this.state.cetegoryModel.PKCategoryID)} type='primary' style={{ marginBottom: 24 }}>
                            Add a root cause
                    </Button>
                        <Table dataSource={this.state.rootcause} components={componants} columns={columns} />

                    </Modal>
                </Spin>
            </div>
        )
    }
}
